<template>
    <span class="sheet-select">
        <span :class="{ 'sheet-select-placeholder': !selectedOption }">{{ selectedText }}</span>
        <b-icon :icon="`chevron-${chevron || 'right'}`" class="sheet-select-chevron" />
        <select v-model="model">
            <option v-if="placeholder" :value="null" disabled>{{ placeholder }}</option>
            <option v-for="option in options" :key="String(option.value)" :value="option.value">{{ option.text }}</option>
        </select>
    </span>
</template>

<script>
// the native select is invisible and covers the nearest positioned ancestor, so the phone shows its own picker
export default {
    name: 'SheetSelect',
    props: ['value', 'options', 'placeholder', 'chevron'],
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        selectedOption() {
            return this.options.find(option => option.value === this.value);
        },
        selectedText() {
            return this.selectedOption ? this.selectedOption.text : this.placeholder;
        },
    },
};
</script>

<style>
.sheet-select {
    display: inline-flex;
    align-items: center;
    gap: 6px;
}
.sheet-select-placeholder {
    color: var(--sheet-label);
}
.sheet-select-chevron {
    color: #777;
    font-size: 12px;
}
.sheet-select select {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    font-size: 16px;
}
</style>
